import "./CategoryCss.css";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { FetchComedy } from "../DataFetching";
import "react-multi-carousel/lib/styles.css";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Box, Button, Modal, } from "@mui/material";
import YouTube from "react-youtube";
import axios from "axios";


const myKey = "850c76a64839953d0d1631f4e46d66b8";
const API_URL = "https://api.themoviedb.org/3/movie";

function Comedy() {
  const comedyMovie = FetchComedy();

  const [loading, setloading] = useState(false);

  useEffect(() => {
    adjustCardsDisplay();
    if (comedyMovie.length !== 0) {
      setbackground(comedyMovie[activeIndex].backgroundImg)
      setTitle(comedyMovie[activeIndex].movieTitle);
      setreleaseDate(
              "Release Date: " + comedyMovie[activeIndex].releaseDate
            );
            setOverview(
              "Overview: " + comedyMovie[activeIndex].movieOverview
            );
            fetchMovieVideos(activeIndex)
    }
    setloading(true);
  }, [comedyMovie.length]);

  const adjustCardsDisplay = () => {
    const customCarouselContainer = document.querySelector(
      ".customCarouselContainer"
    );
    const cardHeight =
      customCarouselContainer.offsetHeight / comedyMovie.length;
    const customCarouselMainContainer = document.querySelector(
      ".customCarouselMainContainer"
    );
    customCarouselMainContainer.style.height = cardHeight * 5 + "px";
    let activeContainer = customCarouselContainer.children[2];
    activeContainer === undefined
      ? (activeContainer = activeContainer)
      : activeContainer.classList.add("active");
  };

  const containerRef = useRef(null);
  const [background, setbackground] = useState(null);
  const [title, setTitle] = useState();
  const [releaseDate, setreleaseDate] = useState();
  const [overview, setOverview] = useState();
  const [prevPosition, setPrevPosition] = useState(0);
  const [activeIndex, setActiveIndex] = useState(2);
  const [activeCard, setActiveCard] = useState();
  const [trailerKey, setTrailerKey] = useState();
  const [categoryModalOpen, setcategoryModalOpen] = useState(false);
  const [movieVideo, setMovieVideo] = useState(null);
  

  const categoryHandleClose = () => setcategoryModalOpen(false)
  const categoryHandleOpen = () => {
    setcategoryModalOpen(true);

  }

  const fetchMovieVideos = async (i) => {
    const selectedData = comedyMovie[i]
      const { data } = await axios.get(`${API_URL}/${selectedData.movieId}`, {
        params: {
          api_key: myKey,
          append_to_response: "videos",
        },
      });
      setMovieVideo(data);
  };


  useEffect(() => {
    if (movieVideo !== null) {
      let trailer = movieVideo.videos.results.find((vid) => {
        if (
          vid.official &&
          (vid.type === "Trailer" ||
            vid.type === "Teaser" ||
            vid.type === "Teaser Trailer") &&
          (vid.name === "Official Trailer" ||
            vid.name === "Official Teaser" ||
            vid.name === "Official Teaser Trailer")
        ) {
          return vid;
        } else {
          return "";
        }
      });

      trailer =
        trailer !== undefined
          ? trailer
          : movieVideo.videos.results.length !== 0
          ? movieVideo.videos.results[movieVideo.videos.results.length - 1]
          : "";
      setTrailerKey(trailer === undefined ? "" : trailer.key);
    }
  }, [movieVideo]);


  useEffect(() => {
    let nothing = null;
    const customCarouselContainer = document.querySelector(
      ".customCarouselContainer"
    );
    if (activeCard === undefined) {
      nothing = null;
    } else {
      activeCard.classList.remove("active");
      setActiveCard(customCarouselContainer.children[activeIndex]);
      fetchMovieVideos(activeIndex)
    }
  }, [activeIndex]);

  useEffect(() => {
    let nothing = null;
    if (activeCard === undefined) {
      nothing = null;
    } else {
      const actives = document.querySelectorAll(".active");
      actives.forEach((active) => {
        active.classList.remove("active");
      });
      activeCard.classList.add("active");
      setbackground(comedyMovie[activeIndex].backgroundImg);
      setTitle(comedyMovie[activeIndex].movieTitle);
      setreleaseDate("Release Date: " + comedyMovie[activeIndex].releaseDate);
      setOverview(comedyMovie[activeIndex].movieOverview);
    }
  }, [activeCard]);

  const cardsScroll = (event) => {
    const customCarouselContainer = document.querySelector(
      ".customCarouselContainer"
    );
    const customCarouselContainerHeight = customCarouselContainer.offsetHeight;
    const currentPosition = event.target.scrollTop;
    const perScrollHeight = customCarouselContainerHeight / comedyMovie.length;
    setActiveCard(customCarouselContainer.children[activeIndex]);

    if (currentPosition > prevPosition) {
      if (
        currentPosition >
        perScrollHeight * (activeIndex - 2) + perScrollHeight / 2
      ) {
        setActiveIndex(activeIndex + 1);
      }
    }

    if (currentPosition < prevPosition) {
      if (
        currentPosition <
        perScrollHeight * (activeIndex - 2) - perScrollHeight / 2
      ) {
        if (
          currentPosition <
          customCarouselContainerHeight - perScrollHeight * 6
        ) {
          setActiveIndex(activeIndex - 1);
        }
      }
    }

    setPrevPosition(currentPosition);
  };

  const readcomedyMovie = () => {
    const movieCards = comedyMovie.map((movie) => {
      const movieTitle = movie.movieTitle;
      const movieId = movie.movieId;
      const movieOverview = movie.movieOverview;
      const backgroundImg = movie.backgroundImg;
      const posterImg = movie.posterImg;
      const releaseDate = movie.releaseDate;

      const cardClick = (event) => {
        const customCarouselContainer = document.querySelector(
          ".customCarouselContainer"
        );
        const customCarouselMainContainer = document.querySelector(
          ".customCarouselMainContainer"
        );
        const perContainerHeight =
          customCarouselContainer.offsetHeight / comedyMovie.length;

        const activeElementIndex = Array.prototype.indexOf.call(
          customCarouselContainer.children,
          event.target.parentNode
        );
        setActiveIndex(activeElementIndex);
        setActiveCard(customCarouselContainer.children[activeIndex]);
        if (activeElementIndex >= 1) {
          customCarouselMainContainer.scrollTop =
            perContainerHeight * (activeElementIndex - 2);
        } else if (activeElementIndex <= comedyMovie.length - 1) {
          customCarouselMainContainer.scrollTop = 0;
        }
      };

      return (
        <li className="card" onClick={cardClick}>
          <img src={backgroundImg} alt={movieTitle} />
        </li>
      );
    });
    return (
      <div className="customMainContainer">
        <div className="customCarouselMainContainer" onScroll={cardsScroll}>
          <ul className="customCarouselContainer">{movieCards}</ul>
        </div>
      </div>
    );
  };

  return (
    <div
      className="categoryRoot"
      ref={containerRef}
      style={{
        background: `linear-gradient(-90deg, #000d 30%, #333a), url(${background})`,
      }}
    >
      <div className="detailsContainer">
        <div className="details">
          <h1 className="title">{title}</h1>
          <Button
            className="categoryTrailerButton"
            onClick={categoryHandleOpen}
            sx={{
              fontWeight: "bold",
              width: "fit-content",
              color: "#fff",
              borderColor: "#fff",
              "&:hover": {
                background: "#000",
                borderColor: "#e2c044",
                color: "#e2c044",
              },
            }}
            variant="outlined"
            startIcon={<PlayArrowIcon />}
          >
            Play Trailer
          </Button>
          <p className="releaseDate">{releaseDate}</p>
          <h2 className="overviewTitle">Overview:</h2>
          <p className="overview">{overview}</p>
        </div>
        <Modal
          open={categoryModalOpen}
          onClose={categoryHandleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: "grid",
            placeItems: "center",
            width: "100%",
            height: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          <Box
            className="modalBox"
            sx={{
              width: "75%",
              maxWidth: "1080px",
              height: "100%",
              boxShadow: 24,
              border: "1px solid #e2c04433",
            }}
          >
            <YouTube
              videoId={trailerKey}
              id="youtubePlayer"
              className="youtubePlayer"
              opts={{ playerVars: { autoplay: 1 } }}
            />
          </Box>
        </Modal>
      </div>
      <div className="customRootCarouselContainer">{readcomedyMovie()}</div>
    </div>
  );
}

export default Comedy;
